import { Suspense } from "react";
import "./App.css";
import MainRouter from "./components/mainRouter/MainRouter";
import { Provider } from "react-redux";
import { store, persistor } from "./store/store";
import { BrowserRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import FullLoader from "./components/fullLoader/FullLoader";
import { PersistGate } from "redux-persist/integration/react";

function App() {
  return (
    <div className="app">
      <Suspense fallback={<FullLoader />}>
        <Provider store={store}>
          <PersistGate loading={<FullLoader />} persistor={persistor}>
            <BrowserRouter>
              <MainRouter />
              <ToastContainer />
            </BrowserRouter>
          </PersistGate>
        </Provider>
      </Suspense>
    </div>
  );
}

export default App;

// import { useState } from "react";
// import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
// import { Elements } from "@stripe/react-stripe-js";
// import { loadStripe } from "@stripe/stripe-js";

// // Use your publishable key here (pk_test_xxx), not secret key

// const stripePromise = loadStripe(
//   "pk_test_51OmJvIL8eQ4NggJiV9KAxJnbVFRd6waULZaIjkmwM1aknvdTAiAdBfRxUvO0QGJisqd17EKrY1Vm1QveL0WDSvAu00HDDaWU4s"
// );

// function App() {
//   return (
// //     <div>
// //       <h1>Stripe Checkout Demo</h1>
// //       <Elements stripe={stripePromise}>
// //         <CheckoutForm />
// //       </Elements>
// //     </div>
// //   );
// // }

// // export default App;

// const CheckoutForm = () => {
//   const stripe = useStripe();
//   const elements = useElements();
//   const [loading, setLoading] = useState(false);
//   const [message, setMessage] = useState("");

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);

//     // 1. Ask your backend to create a PaymentIntent
//     const res = await fetch(
//       "http://localhost:3000/api/stripe/create-payment-intent",
//       {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ amount: 80, currency: "usd" }),
//       }
//     );

//     const { clientSecret, error, paymentIntentId } = await res.json();

//     // if (error) {
//     //   setMessage(error);
//     //   setLoading(false);
//     //   return;
//     // }

//     // // 2. Confirm card payment
//     const result = await stripe.confirmCardPayment(clientSecret, {
//       payment_method: {
//         card: elements.getElement(CardElement),
//       },
//     });

//     console.log("ode", result, paymentIntentId);

//     // if (result.error) {
//     //   setMessage(result.error.message);
//     // } else if (result.paymentIntent.status === "succeeded") {
//     //   setMessage("✅ Payment succeeded! Money is in your Stripe account.");
//     // }

//     // setLoading(false);
//   };

//   return (
//     <form onSubmit={handleSubmit} style={{ maxWidth: 400, margin: "auto" }}>
//       <CardElement />
//       <button disabled={!stripe || loading}>
//         {loading ? "Processing..." : "Pay"}
//       </button>
//       <div>{message}</div>
//     </form>
//   );
// };

// import { useEffect, useState } from "react";

// const VerifyIdentity = () => {
//   const [sdkLoaded, setSdkLoaded] = useState(false);
//   const [sessionToken, setSessionToken] = useState(null);
//   const [inquiryId, setInquiryId] = useState(null);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     if (typeof window === "undefined") return;

//     const checkPersonaLoaded = () => {
//       if (window.Persona) {
//         console.log("✅ Persona loaded");
//         setSdkLoaded(true);
//         return true;
//       }
//       return false;
//     };

//     // Already loaded
//     if (checkPersonaLoaded()) return;

//     // Already appended?
//     if (document.getElementById("persona-sdk")) return;

//     // Append script
//     const script = document.createElement("script");
//     script.src = "https://cdn.withpersona.com/dist/persona.min.js";
//     script.id = "persona-sdk";
//     script.async = true;

//     script.onload = () => {
//       console.log("📦 Script tag loaded");
//       // Sometimes script loads before window.Persona is available, so poll
//       const interval = setInterval(() => {
//         if (checkPersonaLoaded()) {
//           clearInterval(interval);
//         }
//       }, 100);

//       // Fallback timeout after 10 seconds
//       setTimeout(() => clearInterval(interval), 10000);
//     };

//     script.onerror = () => {
//       console.error("❌ Failed to load Persona SDK");
//     };

//     document.body.appendChild(script);
//   }, []);

//   // 2. Fetch session token and inquiry ID from backend
//   useEffect(() => {
//     const fetchSession = async () => {
//       try {
//         const res = await fetch(
//           "http://localhost:3000/api/personna/create-inquiry",
//           {
//             method: "GET",
//             headers: { "Content-Type": "application/json" },
//             //credentials: "include", // Optional: use cookies/session if needed
//           }
//         );

//         const data = await res.json();
//         //console.log("res", data);

//         if (!data?.session_token || !data?.inquiry_id) {
//           throw new Error("Invalid session or inquiry data.");
//         }

//         setSessionToken(data.session_token);
//         setInquiryId(data.inquiry_id);
//         setLoading(false);
//       } catch (error) {
//         console.error("Failed to fetch session token:", error);
//         setLoading(false);
//       }
//     };

//     fetchSession();
//   }, []);

//   console.log("data", inquiryId, sessionToken, sdkLoaded);

//   // 3. Start Persona once everything is ready
//   useEffect(() => {
//     if (sdkLoaded && sessionToken && inquiryId) {
//       const client = new window.Persona.Client({
//         sessionToken,
//         inquiryId,
//         onLoad: (err) => {
//           if (err) {
//             console.error("Persona SDK failed to load:", err);
//             return;
//           }
//           client.open();
//         },
//         onComplete: ({ inquiryId, status }) => {
//           console.log(
//             `✅ Completed inquiry ${inquiryId} with status ${status}`
//           );
//           // Optional: notify backend
//           fetch("/api/personna/inquiry-completed", {
//             method: "POST",
//             headers: { "Content-Type": "application/json" },
//             body: JSON.stringify({ inquiryId, status }),
//           });
//         },
//         onCancel: () => console.log("❌ Verification cancelled"),
//         onError: (err) => console.error("⚠️ Verification error:", err),
//       });

//       return () => {
//         if (client?.destroy) client.destroy();
//       };
//     }
//   }, [sdkLoaded, sessionToken, inquiryId]);

//   return (
//     <div>
//       <h2>Verify Your Identity</h2>
//       {loading ? <p>Loading session...</p> : <p>Starting verification...</p>}
//       <div id="persona-container" />
//     </div>
//   );
// };

// export default VerifyIdentity;

// import { usePlaidLink } from "react-plaid-link";
// import { useEffect, useState } from "react";

// export default function PlaidLinkComponent() {
//   const [linkToken, setLinkToken] = useState(null);

//   useEffect(() => {
//     fetch("http://localhost:3000/api/identity/link-token/create-android", {
//       method: "GET",
//       headers: { "Content-Type": "application/json" },
//     })
//       .then((res) => res.json()) // Parse the body
//       .then((data) => {
//         //console.log("Link token response:", data);
//         const linkToken = data.data?.link_token;
//         if (linkToken) {
//           setLinkToken(linkToken);
//         } else {
//           console.error("Link token missing in response");
//         }
//       })
//       .catch((err) => {
//         console.error("Error fetching link token:", err);
//       });
//   }, []);

//   console.log("link", linkToken);

//   const { open, ready } = usePlaidLink({
//     token: linkToken,
//     onSuccess: (public_token, metadata) => {
//       console.log("all:", linkToken, public_token, metadata);
//     },
//   });

//   return (
//     <button onClick={() => open()} disabled={!ready}>
//       Connect Bank
//     </button>
//   );
// }

// import { useState } from "react";

// // services/paymentService.js
// export async function initializePayment() {
//   const response = await fetch(`http://localhost:3000/api/payment/intialize`, {
//     method: "POST",
//     headers: {
//       "Content-Type": "application/json",
//       // Authorization: `Bearer ${localStorage.getItem("token")}`, // or your auth token
//     },
//   });

//   const data = await response.json();
//   if (!response.ok)
//     throw new Error(data.message || "Failed to initialize payment");
//   return data.data; // Contains `url` and `reference`
// }

// // components/PaymentButton.js

// function PaymentButton() {
//   const [loading, setLoading] = useState(false);

//   const handlePayment = async () => {
//     try {
//       setLoading(true);
//       const { url } = await initializePayment();
//       window.location.href = url; // redirect to Stripe checkout
//     } catch (error) {
//       console.error('Payment initialization failed:', error.message);
//       alert('Error initializing payment');
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <button onClick={handlePayment} disabled={loading}>
//       {loading ? 'Redirecting...' : 'Pay Now'}
//     </button>
//   );
// }

// export default PaymentButton;
